import maplibregl from 'maplibre-gl';

const GEOPF_WMTS_PUBLIC='https://data.geopf.fr/wmts';

// Sources
const OrthoImageryOrthophotosSrc = {
  type: 'raster',
  tileSize: 256,
  tiles: [
    `${GEOPF_WMTS_PUBLIC}?&SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=HR.ORTHOIMAGERY.ORTHOPHOTOS&STYLE=normal&TILEMATRIX={z}&TILEMATRIXSET=PM&TILEROW={y}&TILECOL={x}&FORMAT=image/jpeg&TRANSPARENT=true&`
  ],
};
const GeographicalGridSystemeMapsSrc = {
  type: 'raster',
  tileSize: 256,
  tiles: [
    `${GEOPF_WMTS_PUBLIC}?&SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&TILEMATRIX={z}&TILEMATRIXSET=PM&TILEROW={y}&TILECOL={x}&FORMAT=image/png&TRANSPARENT=true&`
  ],
};
const AdminExpressSrc = {
  type: 'vector',
  tileSize: 512,
  tiles: [
    // 'https://data.geopf.fr/tms/1.0.0/ADMIN_EXPRESS/{z}/{x}/{y}.pbf'
    'https://openmaptiles.geo.data.gouv.fr/data/decoupage-administratif/{z}/{x}/{y}.pbf'
  ],
  promoteId: 'code'
};

// Layers
const OrthoImageryOrthophotosLay = {
  id: 'OrthoImageryOrthophotos',
  type: 'raster',
  source: 'OrthoImageryOrthophotos',
  minzoom: 0,
  paint: {
    'raster-opacity': 0.3
  },
  layout: {
    visibility: 'visible'
  },
};
const GeographicalGridSystemeMapsLay = {
  id: 'GeographicalGridSystemeMaps',
  type: 'raster',
  source: 'GeographicalGridSystemeMaps',
  minzoom: 0,
  paint: {
    'raster-opacity': 0.2
  },
  layout: {
    visibility: 'visible'
  },
};

const AdminExpressLayers = [
  {
    id: 'commune_limites',
    type: 'line',
    source: 'adminexpress',
    'source-layer': 'communes',
    minzoom: 8,
    paint: {
      'line-color': '#187CC6',
      'line-width': 2
    }
  },
  {
    id: 'communes',
    type: 'fill',
    source: 'adminexpress',
    'source-layer': 'communes',
    minzoom: 8,
    paint: {
      'fill-color': '#187CC6',
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        0.4,
        ['boolean', ['feature-state', 'select'], false],
        0.7,
        0.2
      ]
    },
  },
  {
    id: 'commune_labels',
    type: 'symbol',
    source: 'adminexpress',
    'source-layer': 'communes',
    minzoom: 8,
    paint: {
      'text-halo-color': '#FFFFFF',
      'text-halo-width': 1
    },
    layout: {
      'symbol-placement': 'point',
      'text-field': ['get', 'nom'],
      'text-font': ['Open Sans Semi Bold'],
      'text-anchor': 'center',
      'text-justify': 'center',
      'text-offset': [0, 0],
      'text-size': 14,
    }
  },
];

export default {
  style: {
    version: 8,
    glyphs: 'https://fonts.undpgeohub.org/fonts/{fontstack}/{range}.pbf',
    sources: {
      OrthoImageryOrthophotos: OrthoImageryOrthophotosSrc,
      GeographicalGridSystemeMaps: GeographicalGridSystemeMapsSrc,
      adminexpress: AdminExpressSrc,
    },
    layers: [
      OrthoImageryOrthophotosLay,
      GeographicalGridSystemeMapsLay,
      ...AdminExpressLayers
    ],
  },
  maxZoom: 21,
  minZoom: 8,
  // 'center': null,
  // 'zoom': null,
  bounds: new maplibregl.LngLatBounds(
    process.env.VUE_APP_DEFAULT_MAP_BOUNDS ?
      process.env.VUE_APP_DEFAULT_MAP_BOUNDS.split(',') :
      [
        [4.249418317101657, 42.95232374117063],
        [6.021557667180076, 44.06152144441509]
      ]
  ),
  fitBoundsOptions: {
    minZoom: 8,
    maxZoom: 21,
  }
};
